import Vue from 'vue'
import Router from 'vue-router'
import store from '../../index'
import routes from './routes'

Vue.use(Router)

window.addEventListener('popstate', () => {
    store.commit('router/SET_NAVIGATING_BACK')
})

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    },
    routes
})

const checkLoginRedirect = (from, to) => {
    var authed = store.getters['auth/is_authenticated']

    if (from.path === '/account/login' && authed && from.query.redirectto !== to.fullPath) {
        return from.query.redirectto
    }
}

const checkParamRestrictions = (from, to) => {
    var restrictions = to.meta.param_restrictions
    if (restrictions) {
        Object.keys(restrictions).forEach((param_name) => {
            var allowed_values = restrictions[param_name]
            var current_value = to.params[param_name]
            if (!allowed_values.includes(current_value)) {
                return { name: '404' }
            }
        })
    }
}

const checkAuthorization = (from, to) => {
    var authed = store.getters['auth/is_authenticated']
    if (to.name == 'register' && authed) {
        if (to.query.redirectto) {
            return to.query.redirectto
        }
        // var currentUser = store.getters['auth/current_user']
        // if (currentUser.claims.length == 0) return { name: 'purchase' }
        // else if (currentUser.claims.length > 0)
        return { name: 'welcome' }
    } else if (to.meta.require_auth && !authed) {
        var redirect = {
            name: 'register'
        }

        if (to.fullPath != '/') {
            redirect.query = {
                redirectto: to.fullPath
            }
        }
        return redirect
    } else if (!store.getters['auth/has_role'](to.meta.require_role)) {
        return { name: '401' }
    }
}

router.beforeEach((to, from, next) => {
    var redirect = checkAuthorization(from, to)

    if (!redirect) {
        redirect = checkParamRestrictions(from, to)
    }

    if (!redirect) {
        redirect = checkLoginRedirect(from, to)
    }

    if (redirect != null) {
        next(redirect)
    } else {
        next()

        // controls the load spinnner during routing through different app
        // modules using vx-app-module-root component
        store.commit('router/SET_CURRENT_ROUTE', to)

        // HACK: fixing stupid tooltip bug from vuesax
        // var buggedTooltips = document.body.querySelectorAll(':scope > .vs-tooltip')
        // buggedTooltips.forEach((tt) => {
        //     document.body.removeChild(tt)
        // })
    }
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')

    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

router.onError((error) => {
    // console.error('test: ', error)
    // debugger
    // if (/loading chunk \d* failed./i.test(error.message) && navigator.onLine) {
    //     window.location.reload()
    // }
})

export default router
